import {PanelHasFieldTypes} from 'appRedux/actions/analytics/types';

export const getFormFieldsList = (fields: PanelHasFieldTypes[]): string => {
    const results: string[] = [];
    fields.forEach((item: PanelHasFieldTypes) => {
        results.push(item.title);
    });
    return results.join(', ');
};
